export default {
	// Recharge.vue
	recharge: 'チャージ',
	rechargeTip: '①以下振込先へチャージ金額の振込みをお願いいたします。',
	rechargeTip2: '②支払日等振込情報を記載し送信をお願いいたします。',
	payDate: '支払日',
	rechargeType: 'チャージ方式',
	tradeOrderNo: 'オーダ番号',
	payAccount: '銀行口座番号',
	payUser: '銀行口座名義',
	amount: '金額',
	amountJPY: '金額（円）',
	amountCNY: '金額（元）',
	viewRechargeLog: 'チャージレコードの表示',
	submitSuccessTip: '財務担当者の入金確認完了後、デポジット残高に反映されます。少々お待ちください。',
	rechargeAmount: 'チャージ金額',
	submitTime: 'コミット時間',
	verificationCode: '認証コード',
	verificationCodeTip: 'よく見えないので、1枚交換します',
	verificationCodeError: '認証コードが正しくありません',
	bankTransfer: '銀行振込',
	alipay: 'アリペイ',
	wechat: 'ウィーチャット',
	// RechargeList.vue
	rechargeLog: 'チャージ記録',
	userRechargeLog: 'ユーザーチャージ記録',
	rechargeNo: 'チャージフローナンバ',
	auditing: '審査中',
	rechargeSuccess: 'チャージ成功',
	rechargeFailed: 'チャージ失敗',
	cancelled: 'キャンセルされました',
	orderOpr: '注文操作',
	tradeNo: '取引番号',
	userId: 'ユーザーID',
	rechargeState: 'チャージステータス',
	cancelRechargeConfirm: '今回のチャージ記録をキャンセルしますか？',
	JPY: '円',
	tips: "支払口座と支払者情報を保存して下さい。",
	CNY: '元',
	export: '請求書',
	queren: "証明書の名前を確認してください：",
	exchangeRate: '為替レート',
	scVideo: '動画のアップロード',
	scFj: 'アップロード',
	yhName: 'ユーザー ID：',
	rechargeConfirmButtonText:'確定',
	rechargeCancelButtonText:'次回から表示しない',
	rechargeConfirmText:'振込先口座番号が変更となりました。振込み間違いないのようにご注意下さい。',
};
